import script from "./ProviderEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./ProviderEditModal.vue?vue&type=style&index=0&id=e9faa8be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9faa8be"]])

export default __exports__